<template>
  <div class="pagination" v-if="pages.length && pages.length > 1">
    <button @click="goToPage(currentPage - 1)" :disabled="currentPage === 1">
      <span class="mck2">K</span>
      <p v-if="!isMobile">Предишна</p>
    </button>

    <p
      v-for="(page, index) in pages"
      :key="`${page}-${index}`"
      @click="page !== '...' && goToPage(page)"
      class="page"
      :class="{
        'page--active': currentPage === page,
        'page--points': page === '...',
      }"
    >
      {{ page }}
    </p>

    <button
      @click="goToPage(currentPage + 1)"
      :disabled="currentPage === totalPages"
    >
      <p v-if="!isMobile">Следваща</p>
      <span class="mck2">L</span>
    </button>
  </div>
</template>

<script>
import getMobile from "../mixins/getMobile";
export default {
  props: ["currentPage", "total", "size"],
  mixins: [getMobile],
  computed: {
    totalPages() {
      return Math.ceil(this.total / this.size);
    },
    pages() {
      const pages = [];
      if (this.totalPages <= 7) {
        for (let i = 1; i <= this.totalPages; i++) {
          pages.push(i);
        }
      } else {
        if (this.currentPage <= 3) {
          for (let i = 1; i <= 3; i++) {
            pages.push(i);
          }
          pages.push("...");
          pages.push(this.totalPages);
        } else if (this.currentPage >= this.totalPages - 2) {
          pages.push(1);
          pages.push("...");
          for (let i = this.totalPages - 2; i <= this.totalPages; i++) {
            pages.push(i);
          }
        } else {
          pages.push(1);
          pages.push("...");
          for (let i = this.currentPage - 1; i <= this.currentPage + 1; i++) {
            pages.push(i);
          }
          pages.push("...");
          pages.push(this.totalPages);
        }
      }
      return pages;
    },
  },
  methods: {
    goToPage(page) {
      if (page >= 1 && page <= this.totalPages && page !== this.currentPage) {
        this.$emit("updage:page", page);
      }
    },
  },
};
</script>

<style lang="scss">
.pagination {
  display: flex;
  justify-content: center;
  margin: 20px 0;

  button {
    align-items: center;
    border: 1px solid #c7c7cb;
    background: #ffffff;
    color: #2d2e53;
    cursor: pointer;
    display: flex;
    gap: 5px;
    justify-content: center;
    padding: 0 5px;
    max-width: fit-content;
    transition: all 0.3s;

    &:first-of-type {
      border-radius: 4px 0 0 4px;
    }
    &:last-of-type {
      border-radius: 0 4px 4px 0;
    }

    &:hover:not(:disabled) {
      background: #f6f4f4;
    }

    &:disabled {
      background-color: #ccc;
      cursor: not-allowed;
    }
  }

  .page {
    align-items: center;
    border: 1px solid #c7c7cb;
    background: #ffffff;
    cursor: pointer;
    display: flex;
    justify-content: center;
    padding: 0 10px;
    transition: all 0.3s;

    &.page--active {
      background: var(--color-main);
      border-color: var(--color-main);
      color: #ffffff;
    }

    &.page--points {
      background: transparent;
      border: initial;
    }

    &:hover:not(.page--points):not(.page--active) {
      background: #f6f4f4;
    }
  }
}
</style>
